import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { ModalDialog } from '../Modal';
import { getBrand } from '../../stores/dataorch';

const useStyles = makeStyles((theme) => ({
  brand: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '12px',
  },
  brand__name: {
    color: '#4a4a4a',
    margin: '0 0 8px 0',
  },
  section__title: {
    color: '#4a4a4a',
    fontSize: '17px',
    fontWeight: 600,
    fontFamily: 'AvenirNext',
    marginBottom: '2px',
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  section__body: {
    padding: '16px',
    backgroundColor: '#f5f5f5',
  },
  row: {
    display: 'flex',
    gap: '10px',
    marginBottom: '24px',

    '&:last-child': {
      marginBottom: 0,
    },
  },
  col: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '13px',
    fontWeight: 500,
    color: '#96979a',
    marginBottom: '5px',
    textTransform: 'uppercase',
  },
  value: {
    color: '#5a5a5a',
    fontFamily: 'AvenirNext-DemiBold',
  },
  link: {
    display: 'block',
    fontSize: '13px',
    color: '#96979a',
    fontFamily: 'AvenirNext-DemiBold',
    textDecoration: 'underline',
    marginBottom: theme.spacing(0.5),
  },
  logo: {
    maxWidth: '60px',
  },
  logoHeading: {
    padding: '0 8px 8px 0',
  },
}));

function BrandProfile({ selectedBrandId, onOk, onClose, handleOpenTrackingPage }) {
  const classes = useStyles();
  const [brand, setBrand] = useState(null);
  const [customization, setCustomization] = useState(null);

  useEffect(() => {
    if (!selectedBrandId) return;

    getBrand(selectedBrandId)
      .then((response) => {
        const brand = response?.data?.client_profile;
        const clientProfile = response?.data?.client;
        setBrand(brand);
        setCustomization({
          companyName: brand?.is_use_profile_name ? brand?.name : clientProfile?.company,
          logo: brand?.is_use_profile_logo ? brand?.logo : clientProfile?.logo_url,
          label: '',
          email: brand?.is_use_profile_email ? brand?.email : clientProfile?.email,
          phone: brand?.is_use_profile_phone ? brand?.phone_number : clientProfile?.phone_number,
        });
      })
      .catch((error) => console.log(error));
  }, [selectedBrandId]);

  return (
    <ModalDialog title="" open onOk={onOk} onClose={onClose} noActions>
      <div className={classes.brand}>
        {brand?.logo && <img src={brand?.logo} className={`${classes.logo} ${classes.logoHeading}`} alt="" />}
        <h2 className={classes.brand__name}>{brand?.name}</h2>
      </div>
      <section className={classes.section}>
        <div className={classes.section__title}>Brand Contact</div>
        <div className={classes.section__body}>
          <div className={classes.row}>
            <div className={classes.col}>
              <span className={classes.label}>Support Email</span>
              <span className={classes.value}>{brand?.email}</span>
            </div>
            <div className={classes.col}>
              <span className={classes.label}>Support Phone Number</span>
              <span className={classes.value}>{brand?.phone_number}</span>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.col}>
              <span className={classes.label}>Code</span>
              <span className={classes.value}>{brand?.code}</span>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.section}>
        <div className={classes.section__title}>Marketing Contact</div>
        <div className={classes.section__body}>
          <div className={classes.row}>
            <div className={classes.col}>
              <span className={classes.label}>Contact Name</span>
              <span className={classes.value}>{brand?.contact_name}</span>
            </div>
            <div className={classes.col}>
              <span className={classes.label}>Phone Number</span>
              <span className={classes.value}>{brand?.contact_phone_number}</span>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.col}>
              <span className={classes.label}>Email</span>
              <span className={classes.value}>{brand?.contact_email}</span>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.section}>
        <div className={classes.section__title}>Customization</div>
        <a href="#" className={classes.link} onClick={handleOpenTrackingPage}>
          Tracking Page Setting
        </a>
        <div className={classes.section__body}>
          <div className={classes.row}>
            <div className={classes.col}>
              <span className={classes.label}>Company Name</span>
              <span className={classes.value}>{customization?.companyName}</span>
            </div>
            <div className={classes.col}>
              <span className={classes.label}>Logo</span>
              {customization?.logo && <img className={classes.logo} src={customization?.logo} alt="" />}
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.col}>
              <span className={classes.label}>Label Design</span>
              <span className={classes.value}>{customization?.label}</span>
            </div>
            <div className={classes.col}>
              <span className={classes.label}>Email Address</span>
              <span className={classes.value}>{customization?.email}</span>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.col}>
              <span className={classes.label}>Phone Number</span>
              <span className={classes.value}>{customization?.phone}</span>
            </div>
          </div>
        </div>
      </section>
    </ModalDialog>
  );
}

export default BrandProfile;
